import { AppBar, Box, Container, Toolbar } from "@mui/material"
import { UIAppVersion } from "./components/UIAppVersion"
import { UIFullscreen } from "./components/UIFullscreen"
import UILangSelector from "./components/UILangSelector"
import { UILogo } from "./components/UILogo"
import { UIMute } from "./components/UIMute"
import { UIToast } from "./components/UIToast"
import { UIUnlockChapters } from "./components/UIUnlockChapters"

export const UIModule = () => {
  console.info("UIModule render")

  return (
    <>
      <AppBar position="fixed" sx={{ "& > *": { pointerEvents: "none" }, pointerEvents: "none" }}>
        <Container maxWidth={false} >
          <Toolbar disableGutters >
            <UILogo />
            <Box sx={{ flexGrow: 1 }}></Box>
            <UIUnlockChapters />
            <UILangSelector />
            <UIFullscreen />
            <UIMute />
          </Toolbar>
        </Container>
      </AppBar>
      <UIAppVersion />
      <UIToast />
    </>
  )
}